import React from 'react';
import PropTypes from 'prop-types';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Chip, IconButton, Switch } from '@mui/material';
import EditIcon from '@mui/icons-material/EditOutlined';
import DeleteIcon from '@mui/icons-material/Delete';

export default function CategoryTable({
  categoryList,
  openModalUpdate,
  onDisableCategory,
  onDelete,
}) {
  return (
    <TableContainer component={Paper} style={{ borderRadius: 20 }}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>N°</TableCell>
            <TableCell align="left">Name</TableCell>
            <TableCell align="center">Status</TableCell>
            <TableCell align="right">Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {
            // eslint-disable-next-line react/prop-types
            categoryList.map((row, i) => (
              <TableRow key={row.id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                <TableCell component="th" scope="row">
                  {i + 1}
                </TableCell>
                <TableCell align="left">{row.name}</TableCell>
                <TableCell align="center">
                  {row.state ? (
                    <Chip label="Active" color="success" />
                  ) : (
                    <Chip label="Disabled" color="default" />
                  )}
                </TableCell>
                <TableCell align="right">
                  <IconButton edge="end" aria-label="disable">
                    <Switch
                      onClick={() => onDisableCategory(row)}
                      inputProps={{ 'aria-label': 'State category' }}
                      checked={row.state}
                    />
                  </IconButton>
                  <IconButton edge="end" aria-label="edit" onClick={() => openModalUpdate(row)}>
                    <EditIcon color="primary" />
                  </IconButton>
                  <IconButton edge="end" aria-label="delete" onClick={() => onDelete(row)}>
                    <DeleteIcon color="primary" />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))
          }
        </TableBody>
      </Table>
    </TableContainer>
  );
}

CategoryTable.propTypes = {
  openModalUpdate: PropTypes.func.isRequired,
  onDisableCategory: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  categoryList: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      state: PropTypes.bool.isRequired,
    }).isRequired,
  ).isRequired,
};
